import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function setClearInterventionList(draft: Draft<IInterventionData>) {
  draft.getAll.list = [];
}

export default setClearInterventionList;
